import React from "react";

const WalletOutlined = ({ color = "#666666", width = "16", height = "16" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 0H0.625C0.279297 0 0 0.279297 0 0.625V15C0 15.3457 0.279297 15.625 0.625 15.625H15C15.3457 15.625 15.625 15.3457 15.625 15V0.625C15.625 0.279297 15.3457 0 15 0ZM14.2188 9.0625H8.125V6.5625H14.2188V9.0625ZM14.2188 14.2188H1.40625V1.40625H14.2188V5.3125H7.5C7.1543 5.3125 6.875 5.5918 6.875 5.9375V9.6875C6.875 10.0332 7.1543 10.3125 7.5 10.3125H14.2188V14.2188ZM9.14062 7.8125C9.14062 8.0197 9.22293 8.21842 9.36945 8.36493C9.51596 8.51144 9.71467 8.59375 9.92188 8.59375C10.1291 8.59375 10.3278 8.51144 10.4743 8.36493C10.6208 8.21842 10.7031 8.0197 10.7031 7.8125C10.7031 7.6053 10.6208 7.40659 10.4743 7.26007C10.3278 7.11356 10.1291 7.03125 9.92188 7.03125C9.71467 7.03125 9.51596 7.11356 9.36945 7.26007C9.22293 7.40659 9.14062 7.6053 9.14062 7.8125Z"
        fill={color}
      />
    </svg>
  );
};

export default WalletOutlined;
